import * as yup from "yup";
import { createValidationSchema, validate, validateIfFile } from "@";

export const schema = createValidationSchema({
  name: validate("req"),
  title: validate("req"),
  order: validate("number"),
  summary: validate("req"),
  details: validate("req"),
  image: validateIfFile("image", "imageUrl"),
  attributes: validate("array"),
  projectAttributeImage: yup.mixed().nullable(),
});

export const defaultValues = {
  order: 0,
  attributes: [],
  hideFromStore: false,
  showProgressBar: false,
  giftProjectVisualEffect: false,
  attributeGiftingCardDesigns: [],
  details: ".",
  slug: "",
  seoTitle: "",
  seoKeywords: "",
  seoDescription: "",
};
